"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SideBySideWrapper = void 0;
// src/services/component-injection-manager/ui/side-by-side-wrapper.tsx
var preact_1 = require("preact");
var hooks_1 = require("preact/hooks");
var styles = __importStar(require("./side-by-side-wrapper.scss"));
var SideBySideWrapper = function (_a) {
    var player = _a.player, InjectedComponent = _a.component, componentProps = _a.componentProps, replaceVideoWithImageUrl = _a.replaceVideoWithImageUrl;
    var videoContainerRef = (0, hooks_1.useRef)(null);
    (0, hooks_1.useEffect)(function () {
        var videoElement = player.getVideoElement();
        var originalParent = videoElement === null || videoElement === void 0 ? void 0 : videoElement.parentElement;
        if (replaceVideoWithImageUrl) {
            // Image Mode: hide video player in original location
            if (videoElement) {
                videoElement.style.visibility = 'hidden';
            }
            // Cleanup: restore video visibility
            return function () {
                if (videoElement) {
                    videoElement.style.visibility = '';
                }
            };
        }
        // Video Mode: move video element to container (existing behavior)
        if (videoContainerRef.current && videoElement) {
            // Remove from tab order as video controls are managed by the player
            videoElement.tabIndex = -1;
            videoContainerRef.current.prepend(videoElement);
        }
        // Cleanup: restore video element to original location
        return function () {
            if (videoElement && originalParent) {
                originalParent.appendChild(videoElement);
            }
        };
    }, [player, replaceVideoWithImageUrl]);
    var posterUrl = (0, hooks_1.useMemo)(function () {
        return replaceVideoWithImageUrl || player.sources.poster;
    }, [replaceVideoWithImageUrl, player.sources.poster]);
    return ((0, preact_1.h)("div", { className: styles.sideBySideWrapper },
        posterUrl && (0, preact_1.h)("div", { className: styles.posterLayer, style: { backgroundImage: "url(".concat(posterUrl, ")") }, "aria-hidden": "true" }),
        (0, preact_1.h)("div", { className: styles.backdropLayer, "aria-hidden": "true" }),
        (0, preact_1.h)("div", { className: styles.contentLayer },
            (0, preact_1.h)("div", { className: styles.contentContainer },
                (0, preact_1.h)("div", { className: styles.videoContainer, ref: videoContainerRef, "aria-label": replaceVideoWithImageUrl ? 'Image' : 'Video player' }, replaceVideoWithImageUrl && ((0, preact_1.h)("img", { src: replaceVideoWithImageUrl, alt: "Replacement content", className: styles.replacementImage }))),
                (0, preact_1.h)("div", { className: styles.componentContainer, "aria-label": "Injected component" },
                    (0, preact_1.h)(InjectedComponent, __assign({}, componentProps)))))));
};
exports.SideBySideWrapper = SideBySideWrapper;
